<template>
  <div v-if="user && showItem" class="row px-2">
    <button v-bind:id="'btn-'+ menuItem.alias" :class="['hasDropdown btn', menuClass]" :style="btnColor" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse-'+ menuItem.alias" aria-expanded="(backpage !== '' && menuItem.id == backpage) ? 'true' : 'false'" v-bind:aria-controls="'collapse-'+ menuItem.alias">
      <i v-if="icon !== ''" :class="[icon, 'me-2']"></i>
      {{ menuItem.title }}
    </button>
    <div :class="['collapse', (backpage !== '' && menuItem.id == backpage) ? 'show' : '']" v-bind:id="'collapse-'+ menuItem.alias">
        <div v-if="menuItem.items">
             <div v-for="subMenuItem in menuItem.items"
             :key="subMenuItem.id">
            <MenuItem v-if="subMenuItem.type !== 'link' && subMenuItem.type !== 'pdf'"
                      :key="subMenuItem.id"
                      :backpage="menuItem.alias"
                      :menuItem="subMenuItem"
                      :style="btnColor"
                      icon="fas fa-level-up-alt"
                      isSubmenu=true
                      :pathTo="pathTo +'/'+ subMenuItem.alias"
                      :menuClass="menuClass" />
            </div>
        </div>
        <div v-if="menuItem.dates" class="border-top">
            <div class="btn-coesia subtitle"><i class="far fa-calendar-alt me-2"></i> Day by Day</div>
             <div v-for="subMenuItem in menuItem.dates"
             :key="subMenuItem.id">
            <MenuItem
                      :key="subMenuItem.id"
                      :backpage="menuItem.alias"
                      :menuItem="subMenuItem"
                      :style="btnColor"
                      icon="fas fa-level-up-alt"
                      isSubmenu=true
                      :pathTo="pathTo +'/'+ subMenuItem.alias"
                      :menuClass="menuClass" />
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuItem from './MenuItem';

export default {
  name: 'MenuItemSubMenu',
  props: ['menuItem', 'eventItem', 'pathTo', 'menuClass', 'icon', 'subpage', 'endpage', 'backpage'],
  computed: {
    ...mapGetters(['user', 'contactType']),
    showItem () {
      if (this.subpage || this.endpage) return false
      if (this.menuItem.id == 'rooms' && this.user.levelId > 2) {
				let userState = this.contactType(this.eventItem.id, this.user.id)
				if (!userState) return false
				if (userState.isparticipant) return true
				if (userState.isstaff) return true
				return false
			}
      return true
      },
      btnColor() {
          if (this.menuItem.alias !== "rooms") return ""
          return {
              backgroundColor: this.eventItem.btnColor,
              borderColor: this.eventItem.btnColor
          }
      }
  },
  components: {
    MenuItem
  }
}
</script>

<style>
    #event-menu .collapse {
        margin-bottom: 5px;
        background-color: #C81034;
    }
    #event-menu .hasDropdown[aria-expanded="true"] {
        border-radius: .25rem .25rem 0 0;
        padding-bottom: 10px;
    }
    #event-menu .collapse .btn {
        margin: -5px 0 0 !important;
        padding: 15px 15px 15px 75px;
        border-radius: 0;
    }
    .btn:focus, 
    .btn:active {
      box-shadow: none !important;
    }
    #event-menu .collapse .btn.btn-coesia > i {
        left: 50px;
        top: 14px;
    }
    #event-menu .collapse > div:last-child .btn {
        border-radius: 0 0 .25rem .25rem;
    }

    #event-menu .subtitle {
        margin-left: -12px;
        margin-right: -12px;
    }
    #collapse-rooms .btn-coesia {
        background-color: inherit;
        border-color: inherit;
    }
</style>

<style scoped>
</style>
